module.exports = __webpack_public_path__ + "img/2025-ford-expedition.7056d98b.png";